import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { getDisableGeneralChatFromStorage } from '@utils/storage.utils'

export const defaultRouteGuard: CanActivateFn = () => {
  const router = inject(Router)

  const isDisabled = getDisableGeneralChatFromStorage()

  if (isDisabled) {
    router.navigate(['/dashboard/media-library'])
    return false
  }

  router.navigate(['/dashboard/chat'])
  return false
}
